import { FiX } from "react-icons/fi";
import Button from "../../button";
import MintModalStyleWrapper from "./MintNow.style";
import mintImg from "../../../assets/images/nft/home_img.png";
import { useModal } from "../../../utils/ModalContext";
import { MintButton } from "../../../components/common/MintButton";
import { NFT_PRICE } from "../../../config";
import { useNFTMinted } from "../../../hooks/useNFTMinted";
import { ConnectButton } from "../../../components/common/ConnectButton";
import { useAccount } from "wagmi";

const MintNowModal = () => {
  const { isConnected } = useAccount();
  const { data: remaining } = useNFTMinted();
  const { mintModalHandle, visibility } = useModal();

  if (!visibility) {
    return !isConnected ? (
      <ConnectButton />
    ) : (
      <Button lg variant="mint" onClick={mintModalHandle} className="btn-mint">
        Mint Now
      </Button>
    );
  }

  return (
    <>
      <MintModalStyleWrapper className="modal_overlay">
        <div className="mint_modal_box">
          <div className="mint_modal_content">
            <div className="modal_header">
              <h2>signature nft</h2>
              <button onClick={() => mintModalHandle()}>
                <FiX />
              </button>
            </div>
            <div className="modal_body text-center">
              <div className="mint_img">
                <div className="img_card1">
                  <div className="img1">
                    <img src={mintImg} alt="img" />
                  </div>
                  <div className="img1_shapes">
                    <div className="img1_shapes_left">
                      <div className="shape_1"></div>
                      <div className="shape_2"></div>
                    </div>
                    <div className="img1_shapes_right">
                      <div className="shape_3"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mint_count_list">
                <ul>
                  <li>
                    <h5>Remaining</h5>
                    <h5>
                      {remaining}/<span>1000</span>
                    </h5>
                  </li>
                  <li>
                    <h5>Price</h5>
                    <h5>{NFT_PRICE} ETH</h5>
                  </li>
                </ul>
              </div>
              <div className="modal_mint_btn">
                <MintButton />
              </div>
            </div>
          </div>
        </div>
      </MintModalStyleWrapper>
    </>
  );
};

export default MintNowModal;
